module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pegasus/peg_border-34915b7b612e6894b8ce686d20cecc5f.gif";